export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY',
    minimumFractionDigits: 2,
  }).format(amount);
}

export function formatDate(date: string | Date): string {
  return new Intl.DateTimeFormat('tr-TR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date));
}

export function formatShortDate(date: string | Date): string {
  return new Intl.DateTimeFormat('tr-TR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(new Date(date));
}

export const ORDER_STATUS_LABELS: Record<string, string> = {
  pending: 'Beklemede',
  approved: 'Onaylandı',
  completed: 'Tamamlandı',
  cancelled: 'İptal',
};

export function orderStatusBadgeVariant(
  status: string,
): 'default' | 'success' | 'warning' | 'danger' | 'info' {
  switch (status) {
    case 'pending':
      return 'warning';
    case 'approved':
      return 'info';
    case 'completed':
      return 'success';
    case 'cancelled':
      return 'danger';
    default:
      return 'default';
  }
}

export const AD_STATUS_LABELS: Record<string, string> = {
  approved: 'Onaylı',
  pending: 'Beklemede',
  rejected: 'Reddedildi',
};

export const ROLE_LABELS: Record<string, string> = {
  admin: 'Yönetici',
  wholesaler: 'Toptancı',
  restaurant: 'Restoran',
};

export const CAMPAIGN_TYPE_LABELS: Record<string, string> = {
  quantity_discount: 'Miktar İndirimi',
  buy_x_pay_y: 'Al X Öde Y',
  flash_sale: 'Flaş İndirim',
  bundle: 'Paket Kampanya',
};
